const React = require("react");

function MenuIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M4 6h16M4 12h16M4 18h16"
  }));
}

module.exports = MenuIcon;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@heroicons/react/outline/MenuIcon.js
 ** module id = 565
 ** module chunks = 0
 **/